











import { Vue, Component, Prop } from 'vue-property-decorator'
import { date } from 'quasar'
import Papa from 'papaparse'
import { StudentGradebook } from 'src/assets/AttendeeItemData'
import api from 'src/assets/api/gql'
import StudentsAllList from 'src/graphql/student/StudentsAllList.gql'
import { Item, Student, StudentGroup, SessionAttendee } from 'src/graphql/types'

@Component({
  components: {
  }
})
export default class ItemCourseGradebookDownload extends Vue {
  progress: number | null = null
  filedata: Json[] = []

  @Prop()
  readonly courseId!: number

  @Prop({ default: () => new Map() })
  readonly topics!: Map<number, Item>

  @Prop()
  readonly groups!: StudentGroup[]

  get weightTotal () {
    return [...this.topics.values()].reduce((total: number, topic: Item) => total + (topic?.data?.info?.gradebook?.weight || 0), 0)
  }

  get columns () {
    const columns = ['name', 'identity', 'result']
    for (const [id, topic] of this.topics) {
      columns.push(id.toString())
    }
    return columns
  }

  get header () {
    const header: Json = {
      name: this.$t('account.name.title').toString(),
      identity: this.$t('contact.identity').toString(),
      result: this.$t('item.course.gradebook.result').toString()
    }
    for (const [id, topic] of this.topics) {
      header[ id.toString() ] = topic.name
    }
    return header
  }

  beforeDestroy () {
    this.progress = null
  }

  async download () {
    this.progress = 0
    this.filedata = []
    let studentsCount = 0
    let studentsDone = 0
    let studentsLoadCursor = null
    do {
      // @ts-ignore
      const { data: { students } } = await api.query({
        query: StudentsAllList,
        variables: {
          courseId: this.courseId,
          after: studentsLoadCursor
        }
      })
      if (students) {
        studentsCount = students.totalCount
        studentsLoadCursor = students.pageInfo.hasNextPage ? students.pageInfo.endCursor as string : null
        for (const student of students.nodes as Student[]) {
          const gradebook = new StudentGradebook(this.topics, student.sessionAttendees.nodes as SessionAttendee[])
          const data: Json = {
            name: student.publicProfile?.name || '',
            identity: student.contactName,
            result: Math.floor(gradebook.results.total)
          }
          for (const [id, topic] of this.topics) {
            if (gradebook.results[ id ]) {
              if (gradebook.results[ id ].present) {
                if (gradebook.results[ id ].percent === null) {
                  data[ id.toString() ] = '+'
                } else {
                  data[ id.toString() ] = (gradebook.results[ id ].percent || 0).toFixed(1)
                }
              }
            }
          }
          this.filedata.push(data)
          studentsDone++
          this.progress = studentsDone / (studentsCount || 1)
        }
      } else {
        studentsLoadCursor = null
      }
    } while (studentsLoadCursor !== null && this.progress !== null)

    this.filedata.unshift(this.header)
    const data = Papa.unparse(this.filedata, { header: false, columns: this.columns, delimiter: ';' })
    const file  = new Blob([data], { type: 'text/csv' })
    const now = new Date()
    const filename = `Quizenter ${date.formatDate(now, 'YYYY-MM-DD')} at ${date.formatDate(now, 'HH.mm')}.csv`

    const a = document.createElement('a')
    a.style.display = 'none';
    document.body.appendChild(a)
    a.href = window.URL.createObjectURL(file)
    a.setAttribute('download', filename)
    a.setAttribute('target', '_blank')
    a.click()
    document.body.removeChild(a)

    this.progress = null
    this.filedata = []
  }
}
